export const filtertMocks = [
  {
    id: 1,
    image: '/images/chart-match/filters/chart-type-1.jpg',
    description: (
      <>
        Visually represent and compare different entities, variables, or data sets Common types
        include <strong>bar charts, column charts, and radar charts</strong>.
      </>
    ),
  },
  {
    id: 2,
    image: '/images/chart-match/filters/chart-type-2.jpg',
    description: (
      <>
        Visualize proportional relationships within a dataset, depicting each category&apos;s
        contribution to the total. Common types include{' '}
        <strong>pie charts and stacked bar charts</strong>.
      </>
    ),
  },
  {
    id: 3,
    image: '/images/chart-match/filters/chart-type-3.jpg',
    description: (
      <>
        Visually represent data patterns and trends to discern the strength and direction of the
        relationship between variables. Common types include{' '}
        <strong>scatter plots and correlation matrices</strong>.
      </>
    ),
  },
  {
    id: 4,
    image: '/images/chart-match/filters/chart-type-4.jpg',
    description: (
      <>
        Visualize represent patterns, seasonality, and long-term trends within the data. Common
        types include <strong>line charts and area charts</strong>.
      </>
    ),
  },
  {
    id: 5,
    image: '/images/chart-match/filters/chart-type-5.jpg',
    description: (
      <>
        Showcase the distribution of a dataset across different values or ranges. Common types
        include <strong>histograms, box plots, and density plots</strong>.
      </>
    ),
  },
  {
    id: 6,
    image: '/images/chart-match/filters/chart-type-6.jpg',
    description: (
      <>
        <strong>Bar Chart</strong> or <strong>Box Plot</strong> - Ideal for visualizing the
        distribution of the numeric variable across different categories.
      </>
    ),
  },
  {
    id: 7,
    image: '/images/chart-match/filters/chart-type-7.jpg',
    description: (
      <>
        <strong>Grouped Bar Chart</strong> or <strong>Parallel Coordinate Plot</strong> - Suitable
        for comparing multiple numeric variables across categories of a single dimension.
      </>
    ),
  },
  {
    id: 8,
    image: '/images/chart-match/filters/chart-type-8.jpg',
    description: (
      <>
        <strong>Stacked Bar Chart</strong> or <strong>Grouped Bar Chart</strong> with Multiple
        Dimensions - Effective in displaying how the numeric variable varies across categorical
        variables.
      </>
    ),
  },
  {
    id: 9,
    image: '/images/chart-match/filters/chart-type-9.jpg',
    description: (
      <>
        A <strong>Choropleth Map & Scatter Map</strong> is an excellent choice for visualizing the
        geographic distribution or relationship of the dimension with location.
      </>
    ),
  },
  {
    id: 10,
    image: '/images/chart-match/filters/chart-type-10.jpg',
    description: (
      <>
        Helps in visualizing percentages or proportions within a dataset and understanding the
        contribution of each category to the total.{' '}
        <strong>Pie charts and stacked bar charts</strong> are common types of proportion charts.
      </>
    ),
  },
  {
    id: 11,
    image: '/images/chart-match/filters/chart-type-11.jpg',
    description: (
      <>
        <strong>Bar Chart</strong> or <strong>Stacked Bar Chart</strong> - A bar chart or stacked
        bar chart can effectively display the count or proportion of dimensions that have more than
        12 subdimensions.
      </>
    ),
  },
  {
    id: 12,
    image: '/images/chart-match/filters/chart-type-12.jpg',
    description: (
      <>
        <strong>Pie Chart</strong> or <strong>Donut Chart</strong> - A pie chart or donut chart can
        illustrate the proportion of dimensions that do not have more than 12 subdimensions.
      </>
    ),
  },
];
